import React from 'react';

interface PrintContextImageProps {
  imageUrl?: string | null;
  alt?: string;
  className?: string;
  themed?: boolean;
  /** Columna editorial: imagen a un costado, texto al lado (sin float). */
  column?: boolean;
  /** @deprecated Usar column */
  float?: boolean;
}

export function PrintContextImage({
  imageUrl,
  alt = '',
  className = '',
  themed = false,
  column = false,
  float = false,
}: PrintContextImageProps) {
  const src = String(imageUrl || '').trim();
  if (!src) return null;

  const useColumn = column || float;

  const figureClass = [
    'print-context-image',
    'print:break-inside-avoid',
    themed ? 'print-context-image--themed' : '',
    useColumn ? 'print-context-image--column' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const imgClass = [
    'print-context-image__img',
    useColumn ? 'print-context-image__img--column' : 'print-context-image__img--full',
    themed && !useColumn ? 'filter grayscale contrast-125' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <figure className={figureClass}>
      <img src={src} alt={alt} className={imgClass} loading="lazy" />
    </figure>
  );
}
